import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useQuery } from '@tanstack/react-query';
import Typography from '@mui/material/Typography';
import { FieldArrayPath, useFieldArray } from 'react-hook-form';

import { listDiscountsOptions } from '@drivingdoc/api-client/generated/react-query';

import { Discount } from 'types/finance';

import { ChargeFormValues } from '../ChargeSchema';
import DiscountField from './DiscountField';

interface PropTypes {
  name: FieldArrayPath<ChargeFormValues>;
}

function DiscountFieldArray({ name }: PropTypes) {
  const { data } = useQuery(listDiscountsOptions());
  const discounts = data as Discount[] | undefined;
  const fieldArray = useFieldArray({ name: name });

  return (
    <Grid container rowSpacing={3} columnSpacing={1}>
      {fieldArray.fields.map((field, index) => {
        console.log('Field: ', field);
        return <DiscountField key={field?.id} index={index} name={`${name}.${index}`} remove={fieldArray.remove} />;
      })}

      {fieldArray.fields.length === 0 && (
        <Grid size={12}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 'bold',
              textDecoration: 'underline',
            }}
          >
            No Discounts Applied
          </Typography>
        </Grid>
      )}

      <Grid size={12}>
        <Button
          variant="contained"
          size="small"
          fullWidth
          onClick={() => {
            const discount = discounts?.[0];
            fieldArray.append({
              id: null,
              discount_id: discounts?.[0]?.id,
              order: fieldArray.fields.length + 1,
              type: discounts?.[0]?.default_type,
              amount: discount?.default_amount,
            });
          }}
        >
          Add Discount
        </Button>
      </Grid>
    </Grid>
  );
}

export default DiscountFieldArray;
